exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .withTags_tags__haUFJ{margin-bottom:.4rem}[dir=ltr] .withTags_tag__299Iz{margin:.8rem 1.2rem .4rem 0}[dir=rtl] .withTags_tag__299Iz{margin:.8rem 0 .4rem 1.2rem}", ""]);

// Exports
exports.locals = {
	"tags": "withTags_tags__haUFJ",
	"tag": "withTags_tag__299Iz"
};